import NoFreeBoxModal from './NoFreeBoxModal';

export default NoFreeBoxModal;
